// src/components/Layout/InternalPageLayout.js
import React from 'react';
import {
  AppShell,
  Group,
  Title,
  UnstyledButton,
  Container,
  Image,
  Text,
  useMantineColorScheme,
  useMantineTheme
} from '@mantine/core';
import { useMediaQuery } from '@mantine/hooks';
import ThemeToggleButton from './ThemeToggleButton';
import BackgroundImageToggleButton from './BackgroundImageToggleButton';
import LogoutButton from './LogoutButton';
import { Link } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext'; // useAuth is already imported

function InternalPageLayout({ children }) {
  const { userProfile } = useAuth(); // <<< Get userProfile (currentUser still available via useAuth if needed directly)
  const { colorScheme } = useMantineColorScheme();
  const isDark = colorScheme === 'dark';
  const theme = useMantineTheme();

  const isMobile = useMediaQuery(`(max-width: ${theme.breakpoints.sm})`);
  const isExtraSmall = useMediaQuery(`(max-width: ${theme.breakpoints.xs})`);

  return (
    <AppShell
      header={{ height: 60 }}
      padding={0}
      style={{
        minHeight: '100vh',
        display: 'flex',
        flexDirection: 'column'
      }}
    >
      <AppShell.Header>
        <Container size="lg" h="100%">
          <Group h="100%" justify="space-between" align="center" wrap="nowrap">
            <UnstyledButton component={Link} to="/menu" style={{ textDecoration: 'none' }}>
              <Group gap={isMobile ? 'xxs' : 'xs'} align="center" wrap="nowrap">
                <Image
                  src="/Love_alone_whiteBG.png"
                  alt="Love Inc. Logo"
                  h={35}
                  w="auto"
                  fit="contain"
                />
                {isExtraSmall ? (
                  <Title order={4} style={{ lineHeight: 1 }}>Writer Hub™</Title>
                ) : (
                  <Title order={3} style={{ lineHeight: 1 }}>Inc. Writer Hub™</Title>
                )}
              </Group>
            </UnstyledButton>

            <Group gap={isMobile ? 'xs' : 'sm'} align="center" wrap="nowrap">
              {/* Use userProfile?.firstName for the welcome message */}
              {!isExtraSmall && userProfile && userProfile.firstName && (
                <Text
                  size="sm"
                  c={isDark ? 'white' : 'dark.7'}
                  style={{ whiteSpace: 'nowrap' }}
                >
                  Welcome, {userProfile.firstName}!
                </Text>
              )}
              <ThemeToggleButton />
              <BackgroundImageToggleButton />
              <LogoutButton iconOnly={isMobile} />
            </Group>
          </Group>
        </Container>
      </AppShell.Header>

      <AppShell.Main
        style={{
          display: 'flex',
          flexDirection: 'column',
          flexGrow: 1,
        }}
      >
        {children}
      </AppShell.Main>
    </AppShell>
  );
}

export default InternalPageLayout;